import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { Icon } from '../../Icon';
import { css } from '../../Util';
var HeaderIcon = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderIcon, _super);
    function HeaderIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderIcon.prototype.render = function () {
        var titleSizeClass = undefined;
        switch (this.props.titleSize) {
            case 1 /* Large */:
                titleSizeClass = "l";
                break;
            case 2 /* Small */:
                titleSizeClass = "s";
                break;
            case 0 /* Medium */:
            default:
                titleSizeClass = "m";
        }
        return React.createElement("div", { className: css(this.props.className, "bolt-header-icon", titleSizeClass) }, Icon(this.props.iconProps));
    };
    return HeaderIcon;
}(React.Component));
export { HeaderIcon };
